export const Facebook = () => {
  return (
    <svg
      width="14"
      height="27"
      viewBox="0 0 14 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.93577 27.0002V15.2494H0V10.5798H3.93577V6.9006C3.93577 2.90325 6.37832 0.727539
       9.94463 0.727539C11.6534 0.727539 13.121 0.855824 13.5469 0.912269V5.08922H11.0735C9.13387
       5.08922 8.75928 6.01287 8.75928 7.36242V10.5798H13.1364L12.536 15.2494H8.75928V27.0002"
        fill="#051C2C"
      />
    </svg>
  )
}
